


























import { TranslateResult } from 'vue-i18n';
import { Component, Vue, Prop } from 'vue-property-decorator';
import { vxm } from '@/store.vuex';
declare var window: any;


@Component
export default class SsoLogin extends Vue {
  @Prop({ default: () => {} }) facebookLogin;
  @Prop({ default: () => {} }) googleLogin;
  @Prop({ default: () => {} }) loginWithApple;
  @Prop({ default: () => {} }) linkedinLogin;
  @Prop({ default: () => {} }) cancelLogin;

  get enabledAppleSignup(): boolean {
    return false;
  }

  get socialRegistrationConfigs() {
    if (window.WorkLLama.isConfigJSONEnabled === 'true') {
      return vxm.configs.SocialLoginConfig;
    }
    return vxm.jobs.BrandingInfo.SOCIAL_REGISTRATION;
  }

  get enableSocialRegistration() {
    if (
      this.socialRegistrationConfigs.ENABLE_FACEBOOK_REGISTRATION ||
      this.socialRegistrationConfigs.ENABLE_GOOGLE_REGISTRATION ||
      this.socialRegistrationConfigs.ENABLE_LINKDEIN_REGISTRATION
    ) {
      return true;
    }
    return false;
  }

  get buttonProperties() {
    const btnClass =
      'btn btn-sm btn-outline-secondary btn-block text-left col-12';
    const linkClass = 'btn btn-link btn-block col-12';
    return {
      apple: {
        visible: this.enabledAppleSignup,
        icon: require('@/assets/images2.0/icons/appleid-sso.png'),
        text: this.getButtonText('apple'),
        btnClass: btnClass,
        action: this.loginWithApple,
      },
      google: {
        visible: this.socialRegistrationConfigs.ENABLE_GOOGLE_REGISTRATION,
        icon: require('@/assets/images2.0/icons/google-sso.png'),
        text: this.getButtonText('google'),
        btnClass: btnClass,
        action: this.googleLogin,
      },
      linkedin: {
        visible: this.socialRegistrationConfigs.ENABLE_LINKDEIN_REGISTRATION,
        icon: require('@/assets/images2.0/icons/linkedin-sso.png'),
        text: this.getButtonText('linkedin'),
        btnClass: btnClass,
        action: this.linkedinLogin,
      },
      facebook: {
        visible: this.socialRegistrationConfigs.ENABLE_FACEBOOK_REGISTRATION,
        icon: require('@/assets/images2.0/icons/facebook-sso.png'),
        text: this.getButtonText('facebook'),
        btnClass: btnClass,
        action: this.facebookLogin,
      },
    };
  }

  getButtonText(socialNetwork: string): TranslateResult {
    return this.$t('login.button.continue.socialnetwork', {
      social_network_name: this.$t('social.network.name.' + socialNetwork),
    });
  }

  isCancel(value: string): boolean {
    return value === 'cancel';
  }
}
